import { render } from "./TabsPage.vue?vue&type=template&id=72af0c04&ts=true"
import script from "./TabsPage.vue?vue&type=script&lang=ts"
export * from "./TabsPage.vue?vue&type=script&lang=ts"

import "./TabsPage.vue?vue&type=style&index=0&id=72af0c04&lang=css"

import exportComponent from "/Users/chris/Sites/my-celestetic/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__